<template>
  <div class="detail">
    <div class="top_box">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          {{ info.cid ? "编辑课程" : "创建课程" }}
        </div>
        <div class="right"></div>
      </div>
      <!-- <div class="Homeboxtop_nav_tab">
        <span
          style="padding-bottom: 20px"
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName }]"
          :key="index"
          @click="tabClick(item)"
        >
          {{ item.name }}
        </span>
      </div> -->
    </div>
    <div class="main">
      <el-form :inline="false" label-width="125px">
        <el-form-item label="课程名称" :required="true">
          <el-input
            v-model="addData.name.value"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="课程价格">
                    <el-input v-model="addData.jg.value" type="number" placeholder="请输入" style="width:235px"></el-input>
                    <span style="margin-left:10px">元</span>
                </el-form-item> -->
        <!-- <el-form-item label="课程材料" :required="true">
          <el-select
            v-model="addData.mid.value"
            @change="handleMaterial"
            clearable
            filterable
            placeholder="请选择材料"
          >
            <el-option
              v-for="item in materialList"
              :key="item.mid"
              :label="item.mname"
              :value="item.mid"
            >
            </el-option>
            <el-option key="no" label="无材料" value="no">
              <span>无材料</span>
            </el-option>
            <el-option key="add" label="新建材料" value="add">
              <span style="margin-right: 10px">
                <i class="el-icon-plus" />
              </span>
              <span style="color: red">新建材料</span>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="课程封面">
          <div class="material-upload">
            <div class="uploadBtnMore" style="margin-top: 5px">
              <label for="upload_fm">
                <span style="cursor: pointer" size="medium" round class="temp"
                  >上传封面</span
                >
                <input
                  style="display: none"
                  type="file"
                  accept="image/*"
                  :disabled="addData.fm.canClick"
                  id="upload_fm"
                  name="upload_fm"
                  single
                  ref="ipt_fm"
                  @change="uploadFile_fm"
                />
              </label>
            </div>
            <div class="m-l upload-text" style="line-height: 36px">
              允许上传图片的格式为jpg、jpeg、gif、bmp、png建议尺寸大小为：375 *
              210
            </div>
            <ul
              v-if="addData.fm.value[0].previewUrl != ''"
              class="m-t upload-files"
            >
              <li v-for="(item, i) in addData.fm.value" :key="i + item.fid">
                <img :src="item.previewUrl" alt="" class="img" />
                <img
                  src="./imgs/del.svg"
                  alt=""
                  class="del"
                  v-if="item.previewUrl"
                  @click="delFile(i)"
                />
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="授课教师" :required="true">
          <el-select
            v-model="addData.teacher.value"
            clearable
            placeholder="请选择授课教师"
            class="label"
            filterable
          >
            <el-option
              v-for="item in teacherList"
              :key="item.user_id + 'teacherList'"
              :label="item.name"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程类型" :required="true">
          <el-select
            v-model="addData.type.value"
            clearable
            placeholder="请选择课程类型"
            class="label"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id + 'courseType'"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="教学目的" :required="true">
          <el-input v-model="addData.md.value" type="textarea" resize="none" maxlength="200"
            show-word-limit  placeholder="请输入"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="教学要求" :required="true">
                    <el-input v-model="addData.yq.value" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="教学重难点" :required="true">
                    <el-input v-model="addData.nd.value" placeholder="请输入"></el-input>
                </el-form-item> -->
        <el-form-item label="适用年级" :required="true">
          <div class="flex_start">
            <el-checkbox
              :label="'小学'"
              class="one_check"
              :indeterminate="isIndeterminate1"
              @change="CheckedChange1"
              v-model="checkAll1"
              >小学</el-checkbox
            >
            <el-checkbox-group v-model="scope_1">
              <el-checkbox
                v-for="item in list_1"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="flex_start">
            <el-checkbox
              :label="'初中'"
              class="one_check"
              :indeterminate="isIndeterminate2"
              @change="CheckedChange2"
              v-model="checkAll2"
              >初中</el-checkbox
            >
            <el-checkbox-group v-model="scope_2">
              <el-checkbox
                v-for="item in list_2"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="flex_start">
            <el-checkbox
              :label="'高中'"
              class="one_check"
              :indeterminate="isIndeterminate3"
              @change="CheckedChange3"
              v-model="checkAll3"
              >高中</el-checkbox
            >
            <el-checkbox-group v-model="scope_3">
              <el-checkbox
                v-for="item in list_3"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="授课时间安排" :required="true">
          <div class="input-list">
            <p>课时总数</p>
            <el-input
              v-model="addData.course_1.value"
              placeholder="请输入"
              style="width: 200px"
              @input="
                addData.course_1.value = clearNoNumTwo(addData.course_1.value)
              "
            ></el-input>
            <p class="m-l">课时</p>
          </div>
          <div class="input-list">
            <p>课时时长</p>
            <el-input
              v-model="addData.course_2.value"
              placeholder="请输入"
              style="width: 200px"
              @input="
                addData.course_2.value = clearNoNumTwo(addData.course_2.value)
              "
            ></el-input>
            <p class="m-l">分钟</p>
          </div>
          <div class="input-list">
            <p>上课频率</p>
            <el-input
              v-model="addData.course_3.value"
              placeholder="请输入"
              style="width: 200px"
              @input="
                addData.course_3.value = clearNoNumTwo(addData.course_3.value)
              "
            ></el-input>
            <p class="m-l">次/周</p>
          </div>
        </el-form-item>
        <!-- <el-form-item label="课程特点">
          <div
            style="display: flex; margin-bottom: 5px"
            v-for="(item, i) in addData.td.value"
            :key="'001' + i"
          >
            <el-input
              v-model="addData.td.value[i]"
              placeholder="请输入"
              style="margin-right: 15px"
              maxlength="100"
              show-word-limit
            ></el-input>
            <el-button size="small" @click="delTd(i)">删除</el-button>
          </div>
          <el-button size="small" @click="addTd">添加</el-button>
        </el-form-item> -->
        <el-form-item label="视频介绍">
          <div class="material-upload" style="margin-top: 8px">
            <div class="uploadBtnMore">
              <label for="upload_cl">
                <div style="cursor: pointer" @click="uploadTool('cltp')">
                  上传视频
                </div>
                <!-- <span size="medium" round class="temp" @change="uploadFile_cl">上传视频</span>
                                <input style="display: none;" type="file" accept="video/*" :disabled="addData.cltp.canClick" id="upload_cl" name="upload_cl" multiple ref="ipt_cl" @change="uploadFile_cl" /> -->
              </label>
            </div>
            <div class="m-l upload-text">
              <p>允许上传视频的格式为 mkv, mp4, avi, rm, rmvb</p>
            </div>
            <ul class="m-t upload-files" v-if="addData.cltp.value.length>0">
              <li
                v-for="(item, i) in addData.cltp.value"
                :key="i + item.fid"
                class="video_li"
              >
                <video
                  class="video-class"
                  v-if="item.previewUrl != ''"
                  :src="item.previewUrl"
                  controls
                  controlslist="nodownload"
                  :ref="'videoObj' + i"
                ></video>
                <!-- <p  v-else>视频正在解码中···</p> -->
                <img
                  src="./imgs/del.svg"
                  alt=""
                  class="del"
                  v-if="item.previewUrl"
                  @click="delVideo(i)"
                />
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="课程介绍" :required="true">
          <el-input
            v-model="addData.gs.value"
            type="textarea"
            resize="none"
            :rows="5"
            placeholder="请输入"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <footer>
        <!-- <el-button
          style="width: 120px"
          type="primary"
          size=""
          @click="tabName = '上传教案课件'"
          >下一步</el-button
        > -->
        <el-button
          style="width: 120px; margin-bottom: 30px"
          size=""
          @click="toIndex()"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px; width: 120px; margin-bottom: 30px"
          type="primary"
          size=""
          @click="save()"
          >保存</el-button
        >
      </footer>
    </div>
    <!--  上传教案和课件区域-->
    <!-- <div class="main" v-show="tabName === '上传教案课件'">
      <div class="main-title">
        <img src="./imgs/selfAdd_01.svg" alt="" />
        <p :class="{ require: false }">教案简案及详案</p>
        <div class="uploadBtnMore_pl">
          <label for="upload_cl">
            <div @click="uploadTool('file_1')">选择文件</div>
          </label>
        </div>
      </div>
      <div class="table" style="width: 100%">
        <div class="table-header">
          <div style="width: 15%">序号</div>
          <div style="width: 85%">教学简案及详案</div>
        </div>
        <div
          v-if="addData.file_1.value.length > 0"
          v-for="(item, i) in addData.file_1.value"
          :key="i + '授课课件示例'"
          class="table_2_tr"
        >
          <div class="td-1">{{ i + 1 }}</div>
          <div class="td-2">
            <div class="file">
              <div>
                <img src="./imgs/file.svg" alt="" v-if="item.fid" />
                <img src="./imgs/upload.svg" alt="" v-if="!item.fid" />
                <label :for="'upload_two_' + i" class="pointer">
                  <span size="medium" round class="temp">{{
                    !item.fid ? "上传文件" : item.name
                  }}</span>
                </label>
              </div>
              <a v-if="item.fid" href="javascript:;" @click="previewFile(item)"
                >预览</a
              >

              <a
                v-if="item.fid"
                href="javascript:;"
                @click="uplateName(i, 'file_1', item)"
                >重命名</a
              >

              <a href="javascript:;" style="color: red" @click="delTr(i, 'one')"
                >删除</a
              >
            </div>
          </div>
        </div>
        <div v-if="addData.file_1.value.length == 0" class="table_2_tr">
          <div class="td-1">...</div>
          <div class="td-2">
            <div class="file">
              <div>
                <label>
                  <span class="no_temp" size="medium" round>未上传文件</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-title" style="margin-top: 20px">
        <img src="./imgs/selfAdd_02.svg" alt="" />
        <p :class="{ require: false }">授课课件示例</p>
        <div class="uploadBtnMore_pl" style="margin-left: 75%">
          <label for="upload_cl">
            <div @click="uploadTool('file_2')">选择文件</div>
          </label>
        </div>
      </div>
      <div class="table" style="width: 100%">
        <div class="table-header">
          <div style="width: 15%">序号</div>
          <div style="width: 85%">授课课件实例</div>
        </div>
        <div
          v-if="addData.file_2.value.length > 0"
          v-for="(item, i) in addData.file_2.value"
          :key="i + '授课课件示例'"
          class="table_2_tr"
        >
          <div class="td-1">{{ i + 1 }}</div>
          <div class="td-2">
            <div class="file">
              <div>
                <img src="./imgs/file.svg" alt="" v-if="item.fid" />
                <img src="./imgs/upload.svg" alt="" v-if="!item.fid" />
                <label :for="'upload_two_' + i" class="pointer">
                  <span size="medium" round class="temp">{{
                    !item.fid ? "上传文件" : item.name
                  }}</span>
                </label>
              </div>
              <a v-if="item.fid" href="javascript:;" @click="previewFile(item)"
                >预览</a
              >

              <a
                v-if="item.fid"
                href="javascript:;"
                @click="uplateName(i, 'file_2', item)"
                >重命名</a
              >

              <a href="javascript:;" style="color: red" @click="delTr(i, 'two')"
                >删除</a
              >
            </div>
          </div>
        </div>
        <div v-if="addData.file_2.value.length == 0" class="table_2_tr">
          <div class="td-1">...</div>
          <div class="td-2">
            <div class="file">
              <div>
                <label>
                  <span class="no_temp" size="medium" round>未上传文件</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <el-button style="width: 120px" size="" @click="toIndex()"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px; width: 120px"
          type="primary"
          size=""
          @click="save()"
          >保存</el-button
        >
      </footer>
    </div> -->
    <!-- 上传组件 -->
    <res-uploader
      ref="resUploader"
      :visible.sync="upDialogShow"
      @submit="handleUpload"
      :isContinue="isContinue"
      :accept="accept"
    ></res-uploader>
    <!-- 重命名弹框 -->
    <uplate-name
      :visible.sync="renameDialogVisible"
      :nowName="oldFoldName"
      @rename="handleReName"
    ></uplate-name>
  </div>
</template>
<script>
import {
  addCurriculum,
  handleUpdate,
  getMaterialsList,
} from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import axios from "axios";
import _ from "lodash";
import resUploader from "@/components/UploadResource/ResUploader";
import uplateName from "@/components/uplateName.vue";
export default {
  props: ["info"],
  components: {
    resUploader,
    uplateName,
  },
  data() {
    return {
      renameDialogVisible: false,
      upDialogShow: false,
      oldFoldName: "",
      uplateNameType: "",
      uplateNameIndex: "",
      isContinue: true, //是否继续添加
      accept: "", //上传文件的类型
      uploadResourcesType: "", //上传的资源类型
      addData: {
        name: { value: "", title: "课程名称" },
        // jg:{ value:'', title:'课程价格',skip:true},
        mid: { value: "", title: "课程材料", select: {} },
        fm: { value: [{ previewUrl: "" }], title: "课程封面", canClick: false },
        teacher: { value: "", title: "授课教师" },
        type: { value: "", name: "", title: "课程类型" },
        // md: { value: "", title: "教学目的" },
        // yq:{ value:'', title:'教学要求',},
        // nd:{ value:'', title:'教学重难点',},
        check_arr: { value: [], title: "适用年级" },
        course_1: { value: "", title: "课时总数" },
        course_2: { value: "", title: "课时时长" },
        course_3: { value: "", title: "上课频率" },
        td: { value: [""], title: "课程特点", skip: true },
        cltp: {
          value: [],
          title: "视频介绍",
          canClick: false,
          skip: true,
        },
        gs: { value: "", title: "课程介绍" },
        file_1: {
          value: [],
          title: "教案简案及详案",
          canClick: false,
          skip: true,
        },
        file_2: {
          value: [],
          title: "授课课件示例",
          canClick: false,
          skip: true,
        },
      },
      typeList: JSON.parse(sessionStorage.getItem("courseType")) || [],
      teacherList: JSON.parse(sessionStorage.getItem("teacherList")) || [],
      tableData: [],
      tabList: [{ name: "填写课程介绍" }, { name: "上传教案课件" }],
      tabName: "填写课程介绍",
      list_1: [
        { id: "01", label: "一年级" },
        { id: "02", label: "二年级" },
        { id: "03", label: "三年级" },
        { id: "04", label: "四年级" },
        { id: "05", label: "五年级" },
        { id: "06", label: "六年级" },
      ],
      list_2: [
        { id: "11", label: "初一" },
        { id: "12", label: "初二" },
        { id: "13", label: "初三" },
      ],
      list_3: [
        { id: "21", label: "高一" },
        { id: "22", label: "高二" },
        { id: "23", label: "高三" },
      ],
      scope_1: [],
      scope_2: [],
      scope_3: [],
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      isIndeterminate1: false,
      isIndeterminate2: false,
      isIndeterminate3: false,
      canClick: false,
      canClick: false,
      uploadInstance: null,
      userInfo: JSON.parse(window.sessionStorage.getItem("Userlist")) || {},
      materialList: [],
    };
  },
  computed: {},
  watch: {
    "info.cid": function (n, o) {
      if (n) {
        this.init();
        let vm = this.addData,
          obj = this.info;
        if (!obj.resource) obj.resource = [];
        vm.name.value = obj.cname; // 课程名称
        // vm.jg.value= obj.price; //课程价格
        // if (obj.mid) {
        //   (vm.mid.value = obj.mid), // 材料id
        //     (vm.mid.select.mid = obj.mid);
        //   (vm.mid.select.mname = obj.mname), // 材料名称
        //     (vm.mid.select.matAuditState = obj.matAuditState); // 材料审核状态
        // } else {
        //   vm.mid.value = "no";
        // }
        vm.fm.value = [{ previewUrl: obj.coverUrl }]; // 课程封面
        vm.teacher.value = obj.teacherInfo?.personId; // 授课教师
        vm.type.value = obj.typeId; // 课程类型id
        vm.type.name = obj.typeName; // 课程类型名称
        // vm.md.value = obj.teachAims; // 教学目的
        // vm.yq.value= obj.teachRequire;  // 教学要求
        // vm.nd.value= obj.teachDifficulty;   // 教学重难点
        vm.check_arr.value = obj.scope.split(","); // 适用年级
        this.scope_1 = vm.check_arr.value.filter(
          (e) => ["01", "02", "03", "04", "05", "06"].indexOf(e) > -1
        );
        this.scope_2 = vm.check_arr.value.filter(
          (e) => ["11", "12", "13"].indexOf(e) > -1
        );
        this.scope_3 = vm.check_arr.value.filter(
          (e) => ["21", "22", "23"].indexOf(e) > -1
        );
        vm.course_1.value = obj.periodTotal; // 课时总数
        vm.course_2.value = obj.periodTime; // 课时时长
        vm.course_3.value = obj.frequency; // 上课频率
        vm.gs.value = obj.description; // 课程介绍
        // vm.td.value = obj.feature.split("<br/>"); // 课程特点
          console.log("详情--视频", obj.resource,vm.cltp.value);
        if (obj.resource.length > 0) {
          vm.cltp.value = obj.resource.filter((e) => e.source == "0"); // 视频介绍
        }else{
          vm.cltp.value=[]
        }
        // vm.file_1.value = obj.resource.filter((e) => e.source == "2"); // 教案简案及详案
        // vm.file_2.value = obj.resource.filter((e) => e.source == "3"); // 授课课件示例
      } else {
        this.init();
      }
    },
    scope_1(n, o) {
      this.checkAll1 = n.length === 6;
      this.isIndeterminate1 = n.length > 0 && n.length < 6;
    },
    scope_2(n, o) {
      this.checkAll2 = n.length === 3;
      this.isIndeterminate2 = n.length > 0 && n.length < 3;
    },
    scope_3(n, o) {
      this.checkAll3 = n.length === 3;
      this.isIndeterminate3 = n.length > 0 && n.length < 3;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 处理输入框小数点两位问题
    clearNoNumTwo(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      if (obj.indexOf(".") < 0 && obj != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj = parseFloat(obj);
      }
      let strObj = obj.toString();
      if (strObj.indexOf(".") > -1 && strObj === "0.00") {
        obj = parseFloat(obj).toFixed(1);
      }
      return obj;
    },
    async initData() {
      const { result, data } = await getMaterialsList(
        sessionStorage.getItem("orgId")
      );
      console.log("获取下拉框材料列表----", data);
      if (result === "000000") {
        this.materialList = data;
      }
    },
    delFile(i) {
      this.$set(this.addData.fm.value, i, { previewUrl: "" });
    },
    delVideo(i) {
      this.$set(this.addData.cltp.value, i, {
        fid: "",
        source: "",
        name: "",
        downloadUrl: "",
        previewUrl: "",
        ext: "",
      });
      // this.addData.cltp.value.splice(i, 1);
    },
    delTr(i, type) {
      if (type === "one") {
        this.addData.file_1.value.splice(i, 1);
      } else {
        this.addData.file_2.value.splice(i, 1);
      }
    },
    uplateName(i, type, item) {
      // console.log("重名你弹框----",i,type,item);
      this.oldFoldName = item.name;
      this.uplateNameType = type;
      this.uplateNameIndex = i;
      this.renameDialogVisible = true;
    },
    // 文件重命名
    async handleReName(values) {
      // console.log("文件夹重命名----", values);
      this.renameDialogVisible = false;
      this.addData[this.uplateNameType].value[this.uplateNameIndex].name =
        values.name;
    },
    // 上传封面
    async uploadFile_fm(e) {
      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });
      const sourceFiles = this.$refs.ipt_fm.files;
      this.addData.fm.canClick = true;
      try {
        let promiseList = [];
        for (let i = 0; i < sourceFiles.length; i++) {
          let ext = util.getFileExt(sourceFiles[i]["name"]);
          if (sourceFiles[i]["size"] == 0) {
            //大小为0的文件
            this.$message({
              message: `文件${sourceFiles[i]["name"]}是空文件,自动过滤删除`,
              type: "error",
              duration: 1000,
            });
            continue;
          }
          this.addData.fm.value = [
            {
              name: sourceFiles[i]["name"],
              size: this.formatFileSize(sourceFiles[i].size),
              fileLength: sourceFiles[i].size,
              type: this.getExt(ext),
              ext: ext,
              source: "0",
            },
          ];
          const fn = this.uploadInstance.upload(sourceFiles[i], {
            onProgress: (progress) => {},
          });
          promiseList.push(fn);
        }
        const resArr = await Promise.all(promiseList);
        const markIdx = this.addData.fm.value.length - resArr.length;
        console.log(resArr, "itemResitemRes");
        resArr.forEach((res, index) => {
          const itemRes = res.data;
          this.addData.fm.value[markIdx + index].fid = itemRes.fid;
          this.addData.fm.value[markIdx + index].downloadUrl =
            itemRes.downloadUrl;
          if (itemRes.previewUrl) {
            this.addData.fm.value[markIdx + index].previewUrl =
              itemRes.previewUrl;
          } else {
            this.addData.fm.value[markIdx + index].previewUrl =
              itemRes.downloadUrl;
          }
        });
      } catch (error) {
        this.$message({
          message: "上传失败",
          type: "error",
          duration: 1000,
        });
        console.log(error);
      } finally {
        this.addData.fm.canClick = false;
        e.target.value = "";
      }
    },
    // 调用上传的组件
    async uploadTool(type) {
      this.upDialogShow = true;
      if (type == "cltp") {
        this.accept = "video/*";
        this.isContinue = false;
      } else {
        this.accept =
          "audio/*,video/*,image/*,.rar,.zip,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt";
        this.isContinue = true;
      }
      this.uploadResourcesType = type;
    },
    // 上传教案简案及详案   &   上传授课课件示例
    async handleUpload(paramObj) {
      this.addData.cltp.canClick = true;
      this.upDialogShow = false;
      let source;
      if (this.uploadResourcesType == "cltp") {
        source = "0";
      } else if (this.uploadResourcesType == "file_1") {
        source = "2";
      } else {
        source = "3";
      }
      console.log('333333333333333345',paramObj);
      for (let i = 0; i < paramObj.length; i++) {
        let fileObj = {
          fid: paramObj[i].fid,
          name: paramObj[i].titname,
          fileLength: paramObj[i].fileLength,
          ext: util.getFileExt(paramObj[i].titname),
          source: source,
          downloadUrl: paramObj[i].downloadUrl,
          previewUrl: paramObj[i].previewUrl
            ? paramObj[i].previewUrl
            : paramObj[i].downloadUrl,
        };
        this.addData[this.uploadResourcesType].value[0]=fileObj;
        // this.addData[this.uploadResourcesType].value.push(fileObj)
      }
    },
    previewFile(item) {
      window.open(item.previewUrl);
    },
    tabClick(item) {
      this.tabName = item.name;
    },
    toIndex() {
      this.$emit("to-index");
    },
    checkFiles(data, text) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].fid) {
          this.$message.error(text + "有未上传教案");
          return false;
        }
        data[i].classHour = i + 1;
      }
      return data;
    },
    save: _.throttle(
      async function () {
        let vm = this.addData;
        vm.check_arr.value = [
          ...this.scope_1,
          ...this.scope_2,
          ...this.scope_3,
        ].sort((a, b) => {
          return a - b;
        });
        let _addData = {
          name: vm.name,
          teacher: vm.teacher,
          type: vm.type,
          check_arr: vm.check_arr,
          course_1: vm.course_1,
          course_2: vm.course_2,
          course_3: vm.course_3,
          cltp: vm.cltp,
          gs: vm.gs,
        };
        if (!util.checkData(_addData)) {
          return false;
        }
        // let file_1 = this.checkFiles(vm.file_1.value, vm.file_1.title);
        // if (!file_1) return false;
        // let file_2 = this.checkFiles(vm.file_2.value, vm.file_2.title);
        // if (!file_2) return false;
        // let file_arr = [...vm.cltp.value, ...file_1, ...file_2];
        let file_arr = [...vm.cltp.value];
        let courseType = this.typeList.filter((e) => e.id === vm.type.value);
        let teacher = this.teacherList.filter(
          (e) => e.user_id === vm.teacher.value
        );
        let coverUrl;
        if (vm.fm.value[0].previewUrl == "") {
          // https://img1.baidu.com/it/u=1841333429,3927409117&fm=253&fmt=auto&app=138&f=JPEG?w=610&h=500
          coverUrl =
            "https://khfw-1256736654-cdn.huijiaoyun.com/420100/2022/06/28/13/52/1ea551e0944611ec9c53020315a9d89d/84a093eb-08f5-d8ec-05a9-5d4e67be0999/1656395554.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDaw0sXJg9D1Z4KLai3A1dP0MJJDtVYdpm%26q-sign-time%3D1656395556%3B3233195556%26q-key-time%3D1656395556%3B3233195556%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Dac5b6fad1e0ba18aa87546a3ca369bd3791e513e";
        } else {
          coverUrl = vm.fm.value[0].previewUrl;
        }
        let params = {
          cname: vm.name.value, // 课程名称
          // price: vm.jg.value || 0,    // 课程价格
          // mid: vm.mid.select.mid, // 材料id
          // mname: vm.mid.select.mname, // 材料名称
          // matAuditState: vm.mid.select.auditState, // 材料审核状态
          coverUrl: coverUrl, // 课程封面
          typeId: courseType[0].id, // 课程类型
          typeName: courseType[0].label, // 课程类型
          // teachAims: vm.md.value, // 教学目的
          // teachRequire: vm.yq.value,   // 教学要求
          // teachDifficulty: vm.nd.value,  // 教学重难点
          scope: vm.check_arr.value.join(","), // 适用年级
          periodTotal: vm.course_1.value, // 课时总数 736
          periodTime: vm.course_2.value, // 课时时长 9
          frequency: vm.course_3.value, // 上课频率 822
          description: vm.gs.value, // 课程介绍
          // feature: vm.td.value.join("<br/>"), // 课程特点
          resource: file_arr, // 资源 file_arr
          teacherInfo: {
            // 授课教师
            personId: teacher[0].user_id,
            name: teacher[0].name,
          },
          orgType: "2",
          objectives: "",
          supportingDesc: "",
          teachContent: "",
          enrollment: "",
          coverAreas: [
            {
              proviceCode: this.userInfo.province_code,
              proviceName: this.userInfo.province_name,
              cityCode: this.userInfo.city_code,
              cityName: this.userInfo.city_name,
              areaCode: this.userInfo.area_code,
              areaName: this.userInfo.area_name,
            },
          ],
        };
        console.log("点击了保存---", params);
        // if(JSON.stringify(params)==JSON.stringify(this.info)){
        //     this.$message.warning("未进行修改，无法提交")
        //     return;
        // }
        if (this.info.cid) {
          params.cid = this.info.cid;
          params.coverAreas[0].id = this.info.coverAreas[0].id;
          var res = await handleUpdate(params);
          if (res.result === "000000") {
            this.$message.success("编辑成功");
            this.info.cid = null;
            this.init();
            this.$emit("to-init");
            this.toIndex();
          } else {
            this.$message.error("编辑失败");
          }
        } else {
          var res = await addCurriculum(params);
          if (res.result === "000000") {
            this.$message.success("创建成功");
            this.init();
            this.$emit("to-init");
            this.toIndex();
          } else {
            this.$message.error("创建失败");
          }
        }
      },
      3000,
      { leading: true, trailing: false }
    ),

    CheckedChange1(value) {
      this.scope_1 = value ? ["01", "02", "03", "04", "05", "06"] : [];
    },
    CheckedChange2(value) {
      this.scope_2 = value ? ["11", "12", "13"] : [];
    },
    CheckedChange3(value) {
      this.scope_3 = value ? ["21", "22", "23"] : [];
    },
    init() {
      this.addData = {
        name: { value: "", title: "课程名称" },
        fm: { value: [{ previewUrl: "" }], title: "课程封面", canClick: false },
        teacher: { value: "", title: "授课教师" },
        type: { value: "", name: "", title: "课程类型" },
        check_arr: { value: [], title: "适用年级" },
        course_1: { value: "", title: "课时总数" },
        course_2: { value: "", title: "课时时长" },
        course_3: { value: "", title: "上课频率" },
        cltp: {
          value: [
            // {
            //   fid: "",
            //   source: "",
            //   name: "",
            //   downloadUrl: "",
            //   previewUrl: "",
            //   ext: "",
            // },
          ],
          title: "视频介绍",
          canClick: false,
          skip: true,
        },
        gs: { value: "", title: "课程介绍" },
      };
      this.scope_1 = [];
      this.scope_2 = [];
      this.scope_3 = [];
    },
    addFile(type) {
      if (type === "one") {
        this.addData.file_1.value.push({});
      } else {
        this.addData.file_2.value.push({});
      }
    },
    addTd() {
      this.addData.td.value.push("");
    },
    delTd(i) {
      this.addData.td.value.splice(i, 1);
    },
    async getAttachFileByFid(fid) {
      let res = await axios.get(
        "https://filecenter.huijiaoyun.com/filecenter/upload/getAttachFileByFid/" +
          fid
      );
      return res?.data?.data?.previewUrl;
    },
    getExt(ext) {
      return util.getFileType(ext);
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    handleMaterial(id) {
      if (id === "add") {
        this.$router.push({
          path: "/courseManager/materialManger",
          query: { type: "add" },
        });
      } else if (id === "no") {
        this.addData.mid.select = { mid: "", mname: "", auditState: "" };
      } else {
        this.materialList.forEach((item) => {
          if (id === item.mid) {
            this.addData.mid.select = item;
          }
        });
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  .top_box {
    width: 100%;
    height: 60px;
    padding: 0px 30px;
  }
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    padding: 30px;
    position: absolute;
    width: 100%;
    height: calc(100% - 130px);
    // overflow: auto;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
      .require::after {
        content: "*";
        color: #f56c6c;
        margin-left: 4px;
      }
    }
    .input-list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
    .check-title {
      display: inline-block;
      width: 60px;
      color: #606266;
      font-size: 14px;
      padding-left: 3px;
    }
  }
  footer {
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
  }
  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 15%;
      height: 100%;
      float: left;
      border-right: 1px solid #eee;
    }
    .td-2 {
      width: 85%;
      height: 100%;
      float: right;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin: 0 20px;
        }
        span {
          display: inline-block;
          width: 500px;
          height: 30px;
          text-align: left;
          // 省略号
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .no_temp {
          text-align: center;
          width: 800px;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 10px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 48px;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    width: 100%;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
}

.material-upload {
  .uploadBtnMore {
    width: 80px;
    height: 28px;
    font-size: 13px;
    text-align: center;
    line-height: 28px;
    color: #009dfd;
    border-radius: 15px;
    border: 1px solid #009dfd;
    cursor: pointer;
    display: inline-block;
    float: left;
    margin-left: 0px;
    span {
      cursor: pointer;
      display: block;
    }
  }
  .upload-text {
    line-height: 24px;
    color: #999;
    margin-left: 88px;
  }
  .upload-files {
    li {
      display: inline-block;
      position: relative;
      height: 100px;
      width: 150px;
      margin-right: 10px;
      .img {
        max-width: 150px;
      }
      .del {
        position: absolute;
        top: -12px;
        right: -15px;
        cursor: pointer;
        transition: 0s background-color;
      }
      .video-class {
        width: 300px;
      }
    }
    .video_li {
      width: 300px !important;
    }
  }
}
.course-box {
  display: flex;
  margin-bottom: 10px;
  p {
    width: 60px;
    color: #999;
  }
}
.flex_start {
  display: flex;
  .one_check {
    margin-right: 30px;
  }
}
.uploadBtnMore_pl {
  width: 120px;
  height: 30px;
  font-size: 13px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  background-color: #169bd5;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
  margin-left: 73%;
  div {
    cursor: pointer;
  }
  span {
    display: block;
  }
}
.Homeboxtop_nav_tab {
  border-bottom: 1.5px solid #eee;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
} /* chrome */
input[type="number"] {
  -moz-appearance: textfield; /* firefox */
}
</style>
